import { render, staticRenderFns } from "./SIG.vue?vue&type=template&id=052b9186&scoped=true&lang=pug"
import script from "./SIG.vue?vue&type=script&lang=js"
export * from "./SIG.vue?vue&type=script&lang=js"
import style0 from "./SIG.vue?vue&type=style&index=0&id=052b9186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052b9186",
  null
  
)

export default component.exports